import { render, staticRenderFns } from "./CafeMenuSubItem.vue?vue&type=template&id=95f452c0&"
import script from "./CafeMenuSubItem.vue?vue&type=script&lang=js&"
export * from "./CafeMenuSubItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports